var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],staticClass:"tile-img -g-d-f -g-fd-c -g-jc-sb",class:[
    _vm.blok.size,
    {
      'hide-mob': _vm.blok.hide_for_mobile,
      'right': _vm.blok.align_right,
    }
  ]},[(_vm.blok.image && _vm.blok.image.filename)?_c('img',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],staticClass:"tile-img__img",attrs:{"data-src":_vm._f("sbImageService")(_vm.blok.image.filename),"alt":_vm.blok.image.alt,"width":_vm._f("sbImageSize")(_vm.blok.image.filename,'width', _vm.width),"height":_vm._f("sbImageSize")(_vm.blok.image.filename,'height', _vm.height)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }